import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowDownIcon } from "../../assets/images/ArrowDown.svg";
import { styled } from "@mui/system";

export default function ActionDropdown({
  anchorEl,
  setAnchorEl,
  editNavigate,
  setOpen,
  isDelete,
  isActive,
  text,
  markAsActiveInactive,
}) {
  // const [selectedIndex, setSelectedIndex] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const StyledPopover = styled(Popover)(({ theme }) => ({
    "& .MuiPaper-root": {
      boxShadow: "none",
      border: "1px solid #e0e0e0",
      borderRadius: "4px",
    },
    "& .MuiListItemText-primary": {
      fontSize: "14px",
      letterSpacing: "-0.02em",
      fontWeight: 500,
      fontFamily: "Montserrat",
      //   color: "#5a5a5a",
      textAlign: "left",
    },
    "& .MuiList-root": {
      padding: 0,
    },
  }));

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleListItemClick = (event, index) => {
    // setSelectedIndex(index);
    setAnchorEl(null);
    if (index === 1 && isActive) {
      markAsActiveInactive();
    } else if (index === 2 && isDelete) {
      setOpen(true);
    }
  };

  return (
    <div>
      <StyledPopover
        // sx={{ minWidth: "160px" }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{ width: "160px", maxWidth: 360, bgcolor: "background.paper" }}
        >
          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              // selected={selectedIndex === 0}
              onClick={(event) => handleListItemClick(event, 0)}
              component={Link}
              to={editNavigate || ""}
              // style={{ backgroundColor: selectedIndex === 0 ? "#d9d9d9" : "" }}
            >
              <ListItemText sx={{ color: "#5a5a5a" }} primary="Edit" />
            </ListItemButton>
            {isActive && (
              <>
                <Divider sx={{ width: "90%", marginLeft: "8px" }} />
                <ListItemButton
                  // selected={selectedIndex === 1}
                  onClick={(event) => handleListItemClick(event, 1)}
                  component={Link}
                  // style={{ backgroundColor: selectedIndex === 1 ? "#d9d9d9" : "" }}
                >
                  <ListItemText sx={{ color: "#5a5a5a" }} primary={text} />
                </ListItemButton>
              </>
            )}
            {isDelete && (
              <>
                <Divider sx={{ width: "90%", marginLeft: "8px" }} />
                <ListItemButton
                  // selected={selectedIndex === 2}
                  onClick={(event) => handleListItemClick(event, 2)}
                  component={Link}
                  // style={{ backgroundColor: selectedIndex === 2 ? "#d9d9d9" : "" }}
                >
                  <ListItemText sx={{ color: "#a50218" }} primary="Delete" />
                </ListItemButton>
              </>
            )}
          </List>
        </Box>
      </StyledPopover>
    </div>
  );
}

const textStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 500,
  fontFamily: "Montserrat",
  color: "#5a5a5a",
  textAlign: "left",
  width: "136px",
};
